export default __webpack_public_path__ + "static/media/service-thumb-pavers-driveway.2ad6c9f4.jpg";